export default __webpack_public_path__ + "cf37c2f5d3925f71895c7dea046abe97.png";